import logger from './logger';

const GSCOPE_LOGO = `%c
   ______                         
  / ____/_____________  ____  ___ 
 / / __/ ___/ ___/ __ \\/ __ \\/ _ \\
/ /_/ (__  ) /__/ /_/ / /_/ /  __/
\\____/____/\\___/\\____/ .___/\\___/ 
                    /_/           
`;

console.log(
    `${GSCOPE_LOGO} %cMFE Docs: https://gecgithub01.walmart.com/pages/gscope-platform/gscope-mfe-docs/docs/documentation`,
    'color: #fcc229;font-size: 20px',
    'color: #26bfa5;font-size: 15px;',
);

export function displayModules(modules) {
    logger.info('Registered MFE modules:');
    console.table(
        modules.reduce(
            (acc, m) =>
                Object.assign(acc, {
                    [m.moduleName]: Object.assign(
                        {},
                        ...m.activeWhen.map((a, idx) => ({
                            [`Path ${idx + 1}`]: a.path,
                        })),
                    ),
                }),
            {},
        ),
    );
}
